import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./providers/auth-context";
import DemoBar from "./demo-bar";

const DemoBarDemo = () => {
    const { isLoading } = useAuth();
    const { isDemo, isUserPayingCustomer } = useAuth();

    if (isLoading) return null;
    if (!isDemo && isUserPayingCustomer) return null;

    const getUpgradeTo = () => {
        if (isDemo)
            return (
                <>
                    <Link to="/login" style={{ color: "#7c1374" }}>
                        Register
                    </Link>{" "}
                    to get started!
                </>
            );
        if (!isUserPayingCustomer)
            return (
                <>
                    <Link to="/upgrade" style={{ color: "#7c1374" }}>
                        Purchase a license
                    </Link>{" "}
                    to enable functionality.
                </>
            );
        return null;
    };

    return (
        <DemoBar>
            You are currently on <strong>Demo Mode</strong>. {getUpgradeTo()}
        </DemoBar>
    );
};

export default DemoBarDemo;
